import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EndpointService } from '../services/endpoint.service';

export const proxyHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const endpointService = inject(EndpointService);
  const proxyBase = endpointService.getProxyBase();

  const isProxyRequest = proxyBase && req.url.startsWith(proxyBase);

  if (isProxyRequest) {
    const payerOrg = endpointService.getPayerOrgIdentifier();
    let headers = req.headers;

    if (payerOrg) {
      headers = headers.set(EndpointService.PAYER_ORG_HEADER, payerOrg);
    }
    return next(req.clone({ headers }));
  }

  return next(req);
};
